import UserGroupsProvider from './UserGroupsContext';
import UserGroups from './UserGroups';

let Index = () => {
    return (
        <UserGroupsProvider>
            <UserGroups />
        </UserGroupsProvider>
    )
}

export default Index;